// extracted by mini-css-extract-plugin
module.exports = {"welcome":"Cyberdogz_welcome__1J-qI","storypara":"Cyberdogz_storypara__1cAXc"};